import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Button } from 'storybook-ui'

import { selectAppName } from 'root-redux/selects/common'

import { useIsDancebitUsComplianceFlow } from 'hooks/useIsDancebitUsComplianceFlow'
import { useIsSpilioUsaComplianceFlow } from 'hooks/useIsSpilioUsaComplianceFlow'
import { useIsUsGeoRetentionFlow } from 'hooks/useIsUsGeoRetentionFlow'

import { SubscriptionContainer as Container } from 'common-styles'
import {
  APP_BUTTON_THEMES,
  APP_SECONDARY_BUTTON_THEMES,
  AppName,
} from 'root-constants'

type TProps = {
  onClick: () => void
  isMainSubscription?: boolean
}

export const TurnOffRenewalButton: React.FC<TProps> = ({
  onClick,
  isMainSubscription = false,
}) => {
  const { t } = useTranslation()
  const appName = useSelector(selectAppName) as AppName
  const isUsGeoRetentionFlow = useIsUsGeoRetentionFlow()
  const isSpilioUsaComplianceFlow = useIsSpilioUsaComplianceFlow()
  const isDancebitUsComplianceFlow = useIsDancebitUsComplianceFlow()
  const isFitme = appName === AppName.FITME

  if (isDancebitUsComplianceFlow && isMainSubscription) {
    return (
      <Button theme={APP_BUTTON_THEMES[appName]} onClick={onClick}>
        {t('subscription.turnOffRenewal')}
      </Button>
    )
  }

  if (isSpilioUsaComplianceFlow) {
    return (
      <Button
        theme={APP_BUTTON_THEMES[appName]}
        onClick={onClick}
        style={{
          margin: '16px auto',
        }}
      >
        {t('subscription.stopSubscription')}
      </Button>
    )
  }

  if (isUsGeoRetentionFlow) {
    return (
      <Button
        theme={APP_SECONDARY_BUTTON_THEMES[appName]}
        onClick={onClick}
        margin="16px auto"
      >
        {t('button.cancelSubscription')}
      </Button>
    )
  }

  return isFitme ? (
    <Button
      theme={APP_BUTTON_THEMES[appName]}
      onClick={onClick}
      style={{
        margin: '16px auto',
      }}
    >
      {t('subscription.stopSubscription')}
    </Button>
  ) : (
    <Container.ResetPassword onClick={onClick}>
      {t('subscription.turnOffRenewal')}
    </Container.ResetPassword>
  )
}
